import { NO_OFFERS_PRESENT, PROVIDERS, PROVIDER_MAP } from "../../constants";
import { logError } from "../../functions/log";

import type Paths from "@packages/types/front-end-api/v1";

type ReturnedDataFromLeadSubmissionPostRequest =
  | Paths.paths["/api/v1/lead-submission"]["post"]["responses"][200]["content"]["application/json"]
  | Paths.paths["/api/v1/lead-submission"]["post"]["responses"][201]["content"]["application/json"];

export function getProviderNameBasedOnDataAvailability(
  data: ReturnedDataFromLeadSubmissionPostRequest | undefined,
) {
  // Provider returned by Leads API from the Lead Submission
  const leadSubmissionProvider =
    data?.lead_submission?.data?.offers?.[0]?.provider;

  const IS_MISSING_OFFERS_DATA = !data?.lead_submission?.data?.offers?.length;
  const IS_MISSING_PROVIDER = !leadSubmissionProvider;
  if (!leadSubmissionProvider) {
    // If the Lead Submission does not return a provider,
    // we show them the no offers thank you page instead of throwing an error
    const noProviderError = new Error(
      "Lead Submission did not return a provider.",
    );
    logError(noProviderError);
  }

  // This ensures that the user will see the no offers thank you page
  // if the Lead Submission does not return any offers
  // OR if the Lead Submission returns an offer with a provider that is not in the PROVIDER_MAP
  // OR if the Lead Submission returns an offer without a provider at all
  const SHOULD_DEFAULT_TO_NO_OFFERS_PRESENT =
    IS_MISSING_OFFERS_DATA || IS_MISSING_PROVIDER;

  const BULLET_PROOF_PROVIDER = SHOULD_DEFAULT_TO_NO_OFFERS_PRESENT
    ? NO_OFFERS_PRESENT
    : PROVIDERS.DEFAULT;

  // Determine the correct provider name to use for the redirect
  const provider =
    PROVIDER_MAP[leadSubmissionProvider as keyof typeof PROVIDER_MAP] ||
    BULLET_PROOF_PROVIDER;

  return provider;
}
